import { render } from "./productView.vue?vue&type=template&id=5fb5c9ba"
import script from "./productView.vue?vue&type=script&lang=js"
export * from "./productView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__